import { ConcreteEncodable } from "./ConcreteEncodable";

import { CurrencyPairGroupImplEncoder } from "../../encoder/CurrencyPairGroupImplEncoder";

import * as CubiqTS from "../../index";
import { CurrencyPairGroup } from "../CurrencyPairGroup";

export class CurrencyPairGroupImpl extends ConcreteEncodable implements CurrencyPairGroup {
  public static enType: string = "com.bcdfx.model.CurrencyPairGroupImpl";

  /*FID=1*/
  public id: CubiqTS.Long | null = null;
  /*FID=2*/
  public currencypairGroupNm: string;
  /*FID=3*/
  public stamp: CubiqTS.Long | null = null;
  /*FID=4*/
  public groupMembership: Array<CubiqTS.CurrencyPairGroupMember> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CurrencyPairGroupImplEncoder.Instance;
    this.setEncodableType(CurrencyPairGroupImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CurrencyPairGroupImpl[" +
      "id=" +
      this.id +
      "currencypairGroupNm=" +
      this.currencypairGroupNm +
      "stamp=" +
      this.stamp +
      "groupMembership=" +
      this.groupMembership +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
